import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './styles.scss';
import { getUtmParams } from '../../../util/getUtmFromUrl';

const StartModal = (props) => {
    const [utm, setUtm] = useState('');

    React.useEffect(() => {
        setUtm(getUtmParams());
    }, []);

    return (
        <Modal
            show={props.show}
            onHide={() => {
                props.hide();
            }}
            keyboard={false}
            className={'StartModalWrapper'}
            centered
        >
            <Modal.Header className='CTAModalHeader'>
                <div className='HeaderLogo'>
                    {props.engageWith ? (
                        <img
                            src={'https://sw-assets.gumlet.io/engagewith/engagewith-logo-black.svg'}
                            data-src={'https://sw-assets.gumlet.io/engagewith/engagewith-logo-black.svg'}
                            alt={'engagewith'}
                        />
                    ) : (
                        <img
                            src={'https://sw-assets.gumlet.io/trivia/logos/trivia-logo-black.svg'}
                            data-src={'https://sw-assets.gumlet.io/trivia/logos/trivia-logo-black.svg'}
                            alt={'Trivia'}
                        />
                    )}
                </div>
            </Modal.Header>

            <Modal.Body>
                <div className='CTAContent'>
                    {props.login ? (
                        <div className='CTAContentButton'>
                            <div
                                role={'button'}
                                tabIndex={'0'}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) window.open(props.slackLoginUrl, '_blank');
                                }}
                                className='CTA Slack'
                                onClick={() => window.open(props.slackLoginUrl, '_blank')}
                            >
                                <img
                                    src={'https://sw-assets.gumlet.io/common/slack-new.svg'}
                                    data-src={'https://sw-assets.gumlet.io/common/slack-new.svg'}
                                    alt={'slack'}
                                />
                                <div>Sign in with Slack</div>
                            </div>
                            <div
                                role={'button'}
                                tabIndex={'0'}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) window.open(props.teamsLoginUrl, '_blank');
                                }}
                                className='CTA Teams'
                                onClick={() => window.open(props.teamsLoginUrl, '_blank')}
                            >
                                <img
                                    src={'https://sw-assets.gumlet.io/common/teams.png'}
                                    data-src={'https://sw-assets.gumlet.io/common/teams.png'}
                                    alt={'microsoft teams'}
                                />
                                <div>Sign in with Teams</div>
                            </div>
                            {!props.engageWith && (
                                <div
                                    role={'button'}
                                    tabIndex={'0'}
                                    onKeyDown={(e) => {
                                        if (e.keyCode === 13) window.open(props.webLoginUrl, '_blank');
                                    }}
                                    className='CTA Web'
                                    onClick={() => window.open(props.webLoginUrl, '_blank')}
                                >
                                    <img
                                        src={'https://sw-assets.gumlet.io/common/web.svg'}
                                        data-src={'https://sw-assets.gumlet.io/common/web.svg'}
                                        alt={'trivia web'}
                                    />
                                    <div>Sign in with work email</div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className='CTAContentButton'>
                            <div
                                role={'button'}
                                tabIndex={'0'}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13)
                                        window.open(
                                            encodeURI(`${props.slackAddUrl}${props.engageWith ? '' : utm}`),
                                            '_blank'
                                        );
                                }}
                                className='CTA Slack'
                                onClick={() => {
                                    if (window.dataLayer) window.dataLayer.push({ event: 'triviaSlackInstallEvent' });
                                    window.open(
                                        encodeURI(`${props.slackAddUrl}${props.engageWith ? '' : utm}`),
                                        '_blank'
                                    );
                                }}
                                id={props.engageWith ? 'EW-SLACK-INSTALL' : 'TRIVIA-SLACK-INSTALL'}
                            >
                                <img
                                    src={'https://sw-assets.gumlet.io/common/slack-new.svg'}
                                    data-src={'https://sw-assets.gumlet.io/common/slack-new.svg'}
                                    alt={'slack'}
                                />
                                <div>Continue with Slack</div>
                            </div>
                            <div
                                role={'button'}
                                tabIndex={'0'}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13)
                                        window.open(
                                            props.engageWith
                                                ? props.teamsAddUrl
                                                : encodeURI(`${props.teamsAddUrl}${utm}`),
                                            '_blank'
                                        );
                                }}
                                className='CTA Teams'
                                onClick={() => {
                                    if (window.dataLayer) window.dataLayer.push({ event: 'triviaTeamsInstallEvent' });
                                    window.open(
                                        props.engageWith ? props.teamsAddUrl : encodeURI(`${props.teamsAddUrl}${utm}`),
                                        '_blank'
                                    );
                                }}
                                id={props.engageWith ? 'EW-TEAMS-INSTALL' : 'TRIVIA-TEAMS-INSTALL'}
                            >
                                <img
                                    src={'https://sw-assets.gumlet.io/common/teams.png'}
                                    data-src={'https://sw-assets.gumlet.io/common/teams.png'}
                                    alt={'microsoft teams'}
                                />
                                <div>Continue with Teams</div>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default StartModal;
